import * as React from 'react';
export const ListContext = /*#__PURE__*/React.createContext({
  variant: 'default'
});
export const CellContext = /*#__PURE__*/React.createContext({
  grouped: false
});